import { Box, Card, SxProps, Typography } from "@mui/material";
import { overviewCardStyle } from "./backofficeTheme";

export function DashboardCard(
  props: React.PropsWithChildren<{
    title: string;
    topRightCorner?: React.ReactNode;
    sx?: SxProps;
  }>,
) {
  const { title, topRightCorner, sx, children } = props;
  return (
    <Card sx={{ ...overviewCardStyle, ...sx } as any}>
      <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 1, mb: "15px" }}>
        <Typography sx={{ fontWeight: "bold", fontSize: 15, minWidth: 0 }}>{title}</Typography>
        {topRightCorner && <Box sx={{ flexShrink: 0 }}>{topRightCorner}</Box>}
      </Box>
      <Box sx={{ display: "flex", flexDirection: "column", gap: "10px" }}>{children}</Box>
    </Card>
  );
}
